"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const loyaltyPointsStatusInputs = [
  {
    name: "pointsHistoryLabel",
    type: "string",
    required: true,
    friendlyName: "Points history link label",
    defaultValue: "View points history",
  },
  {
    name: "pointsHistoryUrl",
    type: "url",
    required: true,
    friendlyName: "Points history link url",
    defaultValue: "/",
  },
  {
    name: "tiers",
    type: "list",
    subFields: [
      {
        name: "tierName",
        type: "string",
        required: true,
        helperText: "Name of the tier",
      },
      {
        name: "tierCardImage",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
      },
    ],
  },
  {
    name: "ctaButtonLabel",
    friendlyName: "Upper block CTA button label",
    type: "string",
    defaultValue: "See available rewards",
  },
  {
    name: "ctaButtonUrl",
    friendlyName: "Upper block CTA button url",
    type: "url",
    defaultValue: "/",
  },
  {
    name: "secondaryCtaButtonLabel",
    type: "string",
    friendlyName: "Bottom block CTA button label",
    defaultValue: "Earn",
  },
  {
    name: "secondaryCtaButtonUrl",
    type: "url",
    friendlyName: "Bottom block CTA button url",
    defaultValue: "/",
  },
  {
    name: "hideBottomSection",
    type: "boolean",
    friendlyName: "Hide bottom section",
    defaultValue: false,
  },
] as const satisfies Inputs;

export const LoyaltyPointsStatusComponent: RegisteredComponent = {
  name: "LoyaltyPointsStatus",
  component: dynamic(async () =>
    withValidation(
      loyaltyPointsStatusInputs,
      (await import("./LoyaltyPointsStatus")).LoyaltyPointsStatus,
      "LoyaltyPointsStatus"
    )
  ),
  inputs: loyaltyPointsStatusInputs,
  requiresParent: {
    query: {
      "component.name": { $in: ["LoyaltyWrapper"] },
    },
    message: "'LoyaltyPointsStatus' component can only be added inside a 'LoyaltyWrapper'",
  },
};
